function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 37,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    fillRule: "evenodd",
    d: "M18.054 37C8.159 37 .108 28.89.108 18.92.108 8.951 8.159.841 18.054.841 27.95.841 36 8.951 36 18.92 36 28.89 27.95 37 18.054 37zm0-34.769C8.92 2.231 1.488 9.718 1.488 18.92c0 9.201 7.432 16.689 16.566 16.689 9.133 0 16.566-7.488 16.566-16.689 0-9.202-7.433-16.689-16.566-16.689zm6.7 23.439a.686.686 0 0 1-.975 0l-5.725-5.766-5.724 5.766a.686.686 0 0 1-.975 0 .697.697 0 0 1 0-.984l5.723-5.766-5.723-5.767a.695.695 0 0 1 0-.982.684.684 0 0 1 .975 0l5.724 5.766 5.725-5.766a.684.684 0 0 1 .975 0c.27.271.27.711 0 .982l-5.725 5.767 5.725 5.766c.27.273.27.713 0 .984z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.302f59daf9629b2b046a396b802f66d8.svg";
export { ForwardRef as ReactComponent };